import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { branch } from 'baobab-react/higher-order';
import request from 'superagent';
import tree from '../../../state';
import Header from '../../common/Header';
import SupportNav from '.././SupportNav';
import TrackedLink from "../../common/TrackedLink";

var Recaptcha = require('react-recaptcha');

var recaptchaInstance = null;

var callback = function () {
	// console.log('Done!!!!');
};

var verifyCallback = function (response) {
	// console.log(response);
	if (response !== 0 && response !== null) {
		recaptchaInstance = "verified";
	}
};

class ContactUsUnitedKingdom extends Component {


	constructor(props) {
		super(props);
		this.state = {
			flag: true,
		};
		this.handleChange = this.handleChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);

	}


	onSubmit(e) {
		e.preventDefault();
		if (recaptchaInstance === null) {
			alert("Please verify you are not a robot.");
		}
		else {

			const formPayload = {
				"firstName": this.refs.firstName.value,
				"lastName": this.refs.lastName.value,
				"address": this.refs.address.value,
				"address2": this.refs.address2.value,
				"city": this.refs.city.value,
				"county": this.refs.county.value,
				"zip": this.refs.zip.value,
				"phoneNumber": this.refs.phoneNumber.value,
				"emailaddress": this.refs.emailaddress.value,
				"confirmemail": this.refs.confirmemail.value,
				"modelnumber": this.refs.modelnumber.value,
				"serialnumber": this.refs.serialnumber.value,
				"comments": this.refs.comments.value,
				"promotionResponse": document.querySelector('input[name = "promotionresponse"]:checked').value
			};

			this.checkConfirmEmail(formPayload.emailaddress, formPayload.confirmemail);

			if (this.state.flag) {
				request.post('/api/support/contactusunitedkingdom', formPayload)
					.set('authorization', tree.get('token'))
					.type('json')
					.end(function (res) {
						// console.log(res);
						window.location = 'thankyou';
					});
			}
		}
	}

	handleChange(event) {
		this.setState({ [event.target.refs]: event.target.value });
	}

	checkConfirmEmail(email, confirmEmail) {
		if (email !== confirmEmail) {
			alert('email and confirm email should match');
			this.setState({
				flag: false
			});
		} else {
			this.setState({
				flag: true,
			});
		}
	}

	render() {

		return (
			<div className="contact-us">
				<Helmet>
					<title>Contact SentrySafe &#124; United Kingdom &#124; SentrySafe</title>
					<meta name="description" content="The SentrySafe United Kingdom Customer Care Team is dedicated to providing timely and exceptional service and support to our customers. Contact Us Now." />
				</Helmet>
				<SupportNav />

				<Header
					title="Contact Us"
					description="Thank you for contacting us. Please send us an email by filling out the form below."
				/>
				<div className='row'>
					<div className='col sm-7 contactUsForm'>
						<form onSubmit={e => this.onSubmit(e)} >
							<div className="form-group col sm-12">
								<p className="required-text">&#40;&#42;&#41; Indicates a required field</p>
								<h3>Your Personal Information&#58;</h3>
							</div>
							<div className="form-group col sm-6">
								<label className="required-field-label" htmlFor="FirstName">First Name</label>
								<input type="text" id="FirstName" ref="firstName" required="required" />
							</div>

							<div className="form-group col sm-6">
								<label className="required-field-label" htmlFor="LastName">Last Name</label>
								<input type="text" id="LastName" ref="lastName" required="required" />
							</div>

							<div className="form-group col sm-6">
								<label className="required-field-label" htmlFor="Address1">Address Line 1</label>
								<input type="text" id="Address1" ref="address" required="required" />
							</div>

							<div className="form-group col sm-6">
								<label htmlFor="Address2">Address Line 2</label>
								<input type="text" id="Address2" ref="address2" />
							</div>

							<div className="form-group col sm-6">
								<label className="required-field-label" htmlFor="City">Town or City</label>
								<input type="text" id="City" ref="city" required="required" />
							</div>

							<div className="form-group col sm-3">
								<label htmlFor="County">County</label>
								<input type="text" id="County" ref="county" />
							</div>

							<div className="form-group col sm-3">
								<label className="required-field-label" htmlFor="Zip">Zip&#47;Postal Code</label>
								<input type="text" id="Zip" pattern="[a-zA-Z0-9]{2,4}\s{1}[a-zA-Z0-9]{3}" title="Postal code should contain a space" ref="zip" required="required" />
							</div>

							<div className="form-group col sm-6">
								<label className="required-field-label" htmlFor="Email">Email</label>
								<input type="email" id="Email" ref="emailaddress" required="required" />
							</div>

							<div className="form-group col sm-6">
								<label className="required-field-label" htmlFor="ConfirmEmail">Confirm Email</label>
								<input type="email" id="ConfirmEmail" ref="confirmemail" required="required" />
							</div>

							<div className="form-group col sm-6">
								<label className="required-field-label" htmlFor="Phone">Phone Number</label>
								<input type="tel" id="Phone" ref="phoneNumber" required="required" pattern='\d{9,14}' title="No dashes or spaces and nine (9) to fourteen (14) digits long" />
							</div>

							<div className="form-group col sm-7">
								<h3>Your Safe&#39;s Information&#58;</h3>
							</div>

							<div className="form-group col sm-6">
								<label htmlFor="SafeModel">Your Safe&#39;s Model &#35;</label>
								<input type="text" id="SafeModel" ref="modelnumber" />
							</div>

							<div className="form-group col sm-6">
								<label htmlFor="SafeSerial">Your Safe&#39;s Serial &#35;</label>
								<input type="text" id="SafeSerial" ref="serialnumber" />
							</div>

							<div className="form-group col sm-12">
								<TrackedLink to="/support/find-your-model-or-serial-number" target="_blank">Where do I get this information&#63;</TrackedLink>
							</div>

							<div className="form-group col sm-6">
								<label htmlFor="Comments">Please tell us why you&#39;re contacting us&#58;</label>
								<textarea id="Comments" ref="comments" />
							</div>

							<div className="form-group col sm-6 promo">
								<label className="required-field-label" htmlFor="promotionYes">May we contact you regarding site announcements, promotional information, product sampling opportunities or research requests in accordance with our privacy policy&#58;</label>
								<input type="radio"
									name="promotionresponse"
									id="promotionYes"
									value="yes"
									required /><span>Yes</span>
								<input type="radio"
									name="promotionresponse"
									id="promotionNo"
									value="no"
									required /><span>No</span>
							</div>

							<div className="form-group col sm-6">
								<Recaptcha sitekey="6LeNsjUUAAAAAM4fkzXrDfqUOXQIRzSi3vRAHh8B" render="explicit" onloadCallback={callback} verifyCallback={verifyCallback} />
								<button className="btn btn-primary" type="submit">Send Email</button>
							</div>
						</form>
					</div>
					<div className='col sm-4 reach-us'>
						<dl>
							<dt>Other ways to reach us&#58;</dt>
							<dd>
								UK Toll Free Number&#42;&#58; <span>0808&#45;234&#45;2514</span>
							</dd>
							<dd>
								France Toll Free Number&#42;&#58; <span>0800&#45;90&#45;0766</span>
							</dd>
							<dd>
								Belgium Toll Free Number&#42;&#58; <span>0800&#45;7&#45;9429</span>
							</dd>
							<dd>
								Netherlands Toll Free Number&#42;&#58; <span>0800&#45;0224&#45;173</span>
							</dd>
							<dd>
								Germany Toll Free Number&#42;&#58; <span>0800&#45;182&#45;8461</span>
							</dd>
							<dd>
								Spain Toll Free Number&#42;&#58; <span>900&#45;9&#45;81073</span>
							</dd>
							<dd>
								Portugal Toll Free Number&#42;&#58; <span>800&#45;8&#45;11082</span>
							</dd>
							<dd>
								Calls From Other Countries&#58; <span>001&#45;800&#45;828&#45;1438</span>
							</dd>
							<dd>
								&#42;Free of charge if called from a landline. Call from mobile phone may be charged, please refer to your mobile phone provider. SentrySafe helpline is available from Monday through Friday, from 1&#58;30PM to 11PM &#40;GMT&#41;.
							</dd>
						</dl>
					</div>
				</div>
			</div>
		);
	}
};

export default branch({
	stateProvince: ['support', 'stateProvince'],
}, ContactUsUnitedKingdom);


// WEBPACK FOOTER //
// ./src/pages/support/contactUs/ContactUsUnitedKingdom.js